<template>
  <div class="profile-container">
    <div class="profile-title" :class="{ 'align-left': showCards && !isPersonalHome}">
      {{ title }}
    </div>
    <div class="profile-tabs-container">
      <div class="with-profile-tabs--tabs has-3-tabs" :class="{ 'align-left': showCards && !isPersonalHome}">
        <router-link
          to="/profile/update#personal-home" class="profile-tab"
          v-if="availableTabs.includes('personal-home') && !this.isPersonalHomeDisabled"
          :title="$t('profile_settings_personal_home')"
          :class="{'selected': $route.hash === '#personal-home'}"
        >
          {{ $t('profile_settings_personal_home') }}
        </router-link>
        <router-link
          to="/profile/update#notification-settings" class="profile-tab"
          v-if="availableTabs.includes('notification-settings')"
          :title="$t('profile_settings_notification_settings')"
          :class="{'selected': $route.hash === '#notification-settings' || !$route.hash}"
        >
          {{ $t('profile_settings_notification_settings') }}
        </router-link>
        <router-link
          to="/profile/update#password-and-security" class="profile-tab"
          v-if="availableTabs.includes('password-and-security')"
          :title="$t('profile_settings_password')"
          :class="{'selected': $route.hash === '#password-and-security'}"
        >
          {{ $t('profile_settings_password') }}
        </router-link>
        <router-link
          to="/profile/subscription#upgrade" class="profile-tab"
          v-if="availableTabs.includes('upgrade')"
          :title="$t('upgrade')"
          :class="{'selected': $route.hash === '#upgrade' || !$route.hash}"
        >
          {{ $t('upgrade') }}
        </router-link>
        <router-link
          :to="{ name: 'profile', params: { panel: 'subscription'}, hash: '#billing' }"
          class="profile-tab"
          v-if="availableTabs.includes('billing')"
          :title="$t('profile_settings_billing')"
          :class="{'selected': $route.hash === '#billing'}"
        >
          {{ $t('profile_settings_billing') }}
        </router-link>
        <router-link
          to="/profile/subscription#invoices" class="profile-tab"
          v-if="availableTabs.includes('invoices')"
          :title="$t('profile_settings_invoices')"
          :class="{'selected': $route.hash === '#invoices'}"
        >
          {{ $t('profile_settings_invoices') }}
        </router-link>
      </div>
    </div>
    <div class="profile-cards-wrapper" :class="{ 'personal-home-cards': isPersonalHome }" v-if="showCards">
      <ProfileCardsSection :is-personal-home="isPersonalHome" :show-cards="true" @updatedProfilePicture="$emit('updatedProfilePicture')" />
    </div>
    <div class="with-profile-tabs--content" :class="{ 'wider-content': isPersonalHome }">
      <slot/>
    </div>
  </div>
</template>


<script>

  import ProfileCardsSection from '../../components/Profile/ProfileCardsSection.vue'
  import TranslationsMixin from '../../util/TranslationsMixin.js'


  export default {
    props: {
      availableTabs: {
        type: Array,
        default: []
      },
      title: {
        type: String
      },
      showCards: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    computed: {
      isPersonalHome () {
        return this.$route.hash === '#personal-home'
      },
      isPersonalHomeDisabled () {
        return !!this.$store.state.config.personalHomeDisabled
      },
    },
    methods: {},
    components: {
      ProfileCardsSection,
    },
    mounted () {
      if (this.$route.hash === '#personal-home' && this.isPersonalHomeDisabled) {
        this.$router.push('/profile/update#notification-settings')
      }
    },
    mixins: [TranslationsMixin],
  }
</script>

<style lang="scss" scoped>
  @import "../../../scss/variables";

  $profileCardsWidthXL: 350px;
  $profileCardsWidthLG: 300px;
  $profileWidthXL: 1130px;
  $profileWidthLG: 970px;
  .profile-container {
    position: relative;
    height: 100%;
    overflow: auto;
    transition: height .3s;

    hr {
      flex-grow: 1;
      height: 0;
      border: 1px solid var(--primary-extra-lightest);
    }
  }


  .profile-title {
    width: 100%;
    background-color: var(--primary);
    color: white;
    font-size: 26px;
    height: 150px;
    line-height: 150px;
    text-align: center;

    &.align-left {
      padding-right: calc($profileCardsWidthXL / 2);
    }
  }


  .profile-tabs-container {
    background-color: var(--primary-extra-lightest);

    .with-profile-tabs--tabs {
      display: flex;

      .profile-tab {
        color: var(--primary);
        width: 33.3333%;
        height: 50px;
        line-height: 50px;
        cursor: pointer;
        padding: 0 20px;
        text-decoration: none;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;


        &:hover, &.selected {
          background: var(--primary-lightest);
          font-weight: 500;
        }
      }

      &.has-3-tabs {
        .profile-tab {
          @media (min-width: $screen-lg) {
            width: 33%;
          }
        }

        &.align-left {
          .profile-tab {
            @media (min-width: $screen-lg) {
              width: 25%;
            }
          }
        }
      }
    }
  }


  .with-profile-tabs--content, .with-profile-tabs--tabs {
    margin: 0 auto;
  }

  .with-profile-tabs--content.wider-content {
    max-width: none;
    width: 100%;
    padding: 0 20px;
  }



  p {
    margin-bottom: 10px;
    text-align: center;
  }

  @media (min-width: $screen-xl) {
    .with-profile-tabs--content, .with-profile-tabs--tabs {
      &.align-left {
        padding-right: calc($profileCardsWidthXL / 2);
      }

      width: $profileWidthXL;
    }

    .with-profile-tabs--content.wider-content {
      width: 100%;
      max-width: none;
      padding: 0 20px;
    }

    .profile-cards-wrapper {
      margin-right: calc(-1 * (($profileWidthXL / 3) - $profileCardsWidthXL));
      width: $profileCardsWidthXL;
    }

    .profile-cards-wrapper.personal-home-cards {
      right: 20px;
      left: auto;
      margin-right: 0;
    }
  }

  @media (max-width: $screen-xl) {
    .with-profile-tabs--content, .with-profile-tabs--tabs {
      &.align-left {
        padding-right: calc($profileCardsWidthLG / 2);
      }

      width: $profileWidthLG;
    }

    .with-profile-tabs--content.wider-content {
      width: 100%;
      max-width: none;
      padding: 0 20px;
    }

    .profile-cards-wrapper {
      margin-right: calc(-1 * (($profileWidthLG / 3) - $profileCardsWidthLG));
      width: $profileCardsWidthLG;
      left: calc(50% + calc($profileCardsWidthLG / 2));
    }

    .profile-cards-wrapper.personal-home-cards {
      right: 20px;
      left: auto;
      margin-right: 0;
    }
    .profile-title.align-left {
      padding-right: calc($profileCardsWidthLG / 2);
    }
  }

  @media (max-width: $screen-lg) {
    .with-profile-tabs--content, .with-profile-tabs--tabs {
      &.align-left {
        padding-right: 0;
      }

      width: 100%
    }

    .with-profile-tabs--content.wider-content {
      width: 100%;
      max-width: none;
      padding: 0 20px;
    }

    .profile-cards-wrapper {
      margin: 0 auto;
      width: auto;
      max-width: 590px;
      padding: 20px 20px 0 20px;
    }
  }

  @media (max-width: $screen-md) {
    .profile-title {
      padding-right: 0;
    }
  }

  a {
    cursor: pointer;
  }
</style>
